import * as types from '../constants/ActionTypes'

export function editLocation(payload) {
  return { type: types.EDIT_LOCATION, payload }
}
